import { render, staticRenderFns } from "./createDraft.vue?vue&type=template&id=1713aa60&scoped=true"
import script from "./createDraft.vue?vue&type=script&lang=js"
export * from "./createDraft.vue?vue&type=script&lang=js"
import style0 from "./createDraft.vue?vue&type=style&index=0&id=1713aa60&prod&scoped=true&lang=css"
import style1 from "./createDraft.vue?vue&type=style&index=1&id=1713aa60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1713aa60",
  null
  
)

export default component.exports